import { RequestsModule } from "@/store/requests.module";
import { Component, Vue } from "vue-property-decorator";

@Component
export class RequestIdValidatorMixin extends Vue {
    async validateRequestId() {
        const id = Number(this.$route.params.id);
        if (id) {
            await RequestsModule.getRequestList();
            const req = RequestsModule.list.find(
                c => c.record_id === id,
            );
            if (!req) {
                return this.$router.push("/requests");
            }
        }
    }
}
